import styled from 'styled-components';
import { getBackgroundColor, getMediaQuery, getTextColor } from '@magalu/stereo-ui-styles';
export const Input = styled.input`
  display: none;

  &:checked ~ label {
    background-color: ${getBackgroundColor('primary')};
    border-color: ${getBackgroundColor('primary')};
    color: ${getTextColor('white')};
    cursor: default;
  }

  &:disabled ~ label {
    background-color: ${getBackgroundColor('white')};
    color: ${getTextColor('light')};
    cursor: not-allowed;

    img {
      filter: grayscale(1);
      opacity: 0.2;
    }
  }

  &[name='color'] {
    & ~ label {
      background-color: ${getBackgroundColor('white')};
      height: ${({
  height
}) => `${height}`};
      width: ${({
  width
}) => `${width}`};

      & img {
        width: 57px;
        height: 100%;
      }

      &:hover {
        border-color: ${getBackgroundColor('primary')};
      }
    }

    &:checked ~ label {
      border-width: 2px;
    }
  }
`;
export const Container = styled.div`
  position: relative;
  display: inline-flex;

  ${getMediaQuery('large')} {
    &:first-child {
      margin-left: 0;

      label {
        ${({
  type
}) => type === 'volume' && 'border-top-width: 0px'};
      }
    }
  }
`;